// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1sGi2","validationTips":"StatementDescriptor_validationTips__13r9w"};